import { render, staticRenderFns } from "./userPack.vue?vue&type=template&id=12172b5e&scoped=true"
import script from "./userPack.vue?vue&type=script&lang=js"
export * from "./userPack.vue?vue&type=script&lang=js"
import style0 from "./userPack.vue?vue&type=style&index=0&id=12172b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12172b5e",
  null
  
)

export default component.exports